"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StudentAccountController = /** @class */ (function () {
    function StudentAccountController(UserService, UsersModel) {
        var _this = this;
        this.user = UserService.getCurrentUser();
        UsersModel.getStudentByID(UserService.getCurrentUser().id).then(function (response) {
            _this.user = response;
        });
    }
    return StudentAccountController;
}());
StudentAccountController.$inject = ["UserService", "UsersModel"];
exports.default = StudentAccountController;
